import { render, staticRenderFns } from "./UserScopedRole.vue?vue&type=template&id=0263cb28&scoped=true&"
import script from "./UserScopedRole.vue?vue&type=script&lang=js&"
export * from "./UserScopedRole.vue?vue&type=script&lang=js&"
import style0 from "./UserScopedRole.vue?vue&type=style&index=0&id=0263cb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0263cb28",
  null
  
)

export default component.exports